import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { IconTopSearch, IconCrossSm, IconTick } from "../../icons/Icons";
import { Status } from "../../common";
import EmptyState from "../EmptyState/EmptyState";

export class ContentDropdown extends Component {
  state = {
    lisdata: [],
    filteredData: [],
  };
  constructor(props) {
    super(props);
    const filteredData =
      // props.selectedData != undefined
      props.selectedData === undefined
        ? props.list.filter(
            (f) => props.selectedData.map((m) => m.id).indexOf(f.id) == -1
          )
        : props.list;
    this.state = {
      lisdata: filteredData,
      filteredData: filteredData,
    };
  }

  componentDidMount() {}

  componentDidUpdate() {
    // if (this.state.lisdata.length != this.props.list.length) {
    //   this.setState({ lisdata: this.props.list });
    // }
  }
  onMoveEnd = (newList) => {
    console.log(newList);
  };
  // onAddClick = (data, setMethod) => {
  //   if (this.props) {
  //     this.props.onAdd(
  //       data,
  //       setMethod,
  //       this.props.touchedMethod,
  //       this.props.touchedData
  //     );
  //     const updatedLisData = this.state.lisdata.filter(
  //       (item) => item.id !== data.id
  //     );
  //     this.setState({ lisdata: updatedLisData });
  //   }
  // };
  onAddClick = (data, setMethod) => {
    if (this.props) {
      const { expiryDate } = data;
      this.props.onAdd(
        data,
        setMethod,
        this.props.touchedMethod,
        this.props.touchedData,
        expiryDate
      );

      const updatedLisData = this.state.lisdata.filter(
        (item) => item.id !== data.id
      );
      this.setState({ lisdata: updatedLisData });
    }
  };

  onSearch = (value) => {
    let data = this.state.filteredData.filter(
      (item) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
    this.setState({ lisdata: data });
  };

  render() {
    return (
      <div className="mwidth-440">
        <label className="labelField">
          Content<span style={{ color: "red" }}> * </span>
        </label>
        {this.props.getSelectedContentViewList}
        <div className="input-group myInput">
          <input
            className="input form-control"
            list="brow"
            onChange={(e) => this.onSearch(e.target.value)}
            placeholder="Search by content title"
          />
          {/* <button onClick={() => this.onAddClick(null)}>
            <IconCrossSm />
          </button> */}
        </div>

        <ul className="customSelval p-0">
          {/* {this.props.getSelectedContentViewList}

          {this.state.lisdata.map((item, index) => (
            <li key={index + "_ContentDropDownListItem"}>
              <div className="align-items-center d-flex gap-3 bg-gray-600 borderAll p-12 rounded-6 mwidth-440 position-relative mb-12 cursor-pointer">
              <div>
                  <p className="mb-0 text-sm">  </p>
                </div> 
                <div className="fullDiv" style={{ marginRight: "20%" }}>
                  {item?.status != undefined && (
                    <p
                      className="mb-0 text-md text-primary-200"
                      style={{ marginBottom: "1%" }}
                    >
                      {item?.type ?? ""}
                      <span
                        className={`tableTag ${
                          Status[item.status].color
                        } text-md  `}
                      >
                        <IconTick /> 
                        {item.status}
                      </span>
                      {item.status === "Draft" && (
                        <span
                          className={`tableTag ${
                            Status[item.status].color
                          } text-md`}
                        >
                          {item.status}
                        </span>
                      )}
                    </p>
                  )}
                  <p className="mb-0 mt-1 text-truncate">
                    <strong className="wordWrap"> {item?.title ?? ""} </strong>
                  </p>
                </div>

                <div className="crossBtn">
                  <button
                    className="text-base-100 btn-sm btn btn-secondary font-normal"
                    onClick={() => this.onAddClick(item, this.props.setMethod)}
                  >
                    Add
                  </button>
                </div>
              </div>
            </li>
          ))}
          </ul> */}

          {this.state.lisdata.map((item, index) => (
            <li
              key={index + "_ContentDropDownListItem"}
              onClick={() => this.onAddClick(item, this.props.setMethod)}
              className="cursor-pointer"
            >
              <div className="d-flex align-items-center justify-content-between gap-3 bg-gray-600 border border-gray-400 py-12 px-3 rounded-6 mb-12">
                {item?.status != undefined && (
                  <>
                    <div className="d-flex justify-content-start align-items-cente gap-2">
                      <h5 className="text-truncate h5 mb-0 wordWrap font-medium itemTitle">
                        {item?.title ?? ""}
                      </h5>
                      {item.status === "Draft" && (
                        <div className="status draft">Draft</div>
                      )}
                      {item.status === "Published" && (
                        <div className="status published">Published</div>
                      )}
                      {item.status === "Active" && (
                        <div className="status active">Active</div>
                      )}
                    </div>
                    <div className="text-md text-gray-300">
                      {item?.type ?? ""}
                    </div>
                  </>
                )}
              </div>
            </li>
          ))}
        </ul>
        {!this.state.lisdata.length > 0 && (
          <div className="mt-3">
            <EmptyState message={"No content found"} />
          </div>
        )}
      </div>
    );
  }
}

export default ContentDropdown;
